<!-- Car Model Add/Edit Modal -->
<div class="modal fade" id="kt_modal_car_model_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content" style="overflow: visible;">
      <div class="modal-header" id="kt_modal_car_model_add_edit_header">
        <h2 class="fw-bold">{{ isEditMode ? 'Edit Car Model' : 'Add Car Model' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" aria-label="Close">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <div class="modal-body px-5 my-7" style="overflow: visible;">
        <form [formGroup]="carModelForm" (ngSubmit)="onSubmit()">
          <div class="d-flex flex-column px-5 px-lg-10" style="overflow: visible;">

            <!-- Name -->
            <div class="row mb-5">
              <div class="col-md-12">
                <label class="form-label required">Name</label>
                <input
                  type="text"
                  class="form-control form-control-solid"
                  formControlName="name"
                  placeholder="Enter car model name"
                  [class.is-invalid]="name?.invalid && name?.touched"
                />
                <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
                  <div *ngIf="name?.errors?.['required']">Car model name is required</div>
                  <div *ngIf="name?.errors?.['minlength']">Car model name must be at least 2 characters</div>
                </div>
              </div>
            </div>

            <!-- M3 -->
            <div class="row mb-5">
              <div class="col-md-12">
                <label class="form-label required">M3</label>
                <input
                  type="text"
                  class="form-control form-control-solid"
                  formControlName="m3"
                  placeholder="Enter M3 value"
                  [class.is-invalid]="m3?.invalid && m3?.touched"
                />
                <div *ngIf="m3?.invalid && m3?.touched" class="invalid-feedback">
                  <div *ngIf="m3?.errors?.['required']">M3 is required</div>
                </div>
              </div>
            </div>

            <!-- Parent (Car Maker) -->
            <div class="row mb-5">
              <div class="col-md-12">
                <label class="form-label required">Parent</label>
                <select
                  class="form-select form-select-solid"
                  formControlName="parent"
                  [class.is-invalid]="parent?.invalid && parent?.touched"
                >
                  <option value="">Select car maker</option>
                  <option *ngFor="let carMaker of carMakers" [value]="carMaker.slug">
                    {{ carMaker.name }}
                  </option>
                </select>
                <div *ngIf="parent?.invalid && parent?.touched" class="invalid-feedback">
                  <div *ngIf="parent?.errors?.['required']">Parent car maker is required</div>
                </div>
                <div *ngIf="isLoadingCarMakers" class="text-muted mt-2">
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Loading car makers...
                </div>
              </div>
            </div>

            <!-- Vehicle Type -->
            <div class="row mb-5">
              <div class="col-md-12">
                <label class="form-label required">Vehicle Type</label>
                <select
                  class="form-select form-select-solid"
                  formControlName="vehicle_type"
                  [class.is-invalid]="vehicle_type?.invalid && vehicle_type?.touched"
                >
                  <option value="">Select vehicle type</option>
                  <option *ngFor="let vehicleType of vehicleTypes" [value]="vehicleType._id || vehicleType.id">
                    {{ vehicleType.name }}
                  </option>
                </select>
                <div *ngIf="vehicle_type?.invalid && vehicle_type?.touched" class="invalid-feedback">
                  <div *ngIf="vehicle_type?.errors?.['required']">Vehicle type is required</div>
                </div>
                <div *ngIf="isLoadingVehicleTypes" class="text-muted mt-2">
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Loading vehicle types...
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="carModelForm.invalid || isLoading"
          (click)="onSubmit()">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
          {{ isEditMode ? 'Update' : 'Save' }}
        </button>
      </div>
    </div>
  </div>
</div>
